//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { MU_UPATE_AUTH } from "store/index";
import BasicInfo from "page/xSchool/manager/BasicInfo.vue";
import PassWordEdit from "page/xSchool/manager/PassWordEdit.vue";
import phoneNumber from "page/xSchool/manager/phoneNumber.vue";
import BannerManger from "page/xSchool/manager/BannerManger.vue";
import FileManager from "page/xSchool/56xSystemManager/uploadFileManager.vue";
import examInfoManager from "page/xSchool/56xSystemManager/examInfoManager.vue";
export default {
  data: function data() {
    return {
      tabName: "first"
    };
  },
  components: {
    BasicInfo: BasicInfo,
    PassWordEdit: PassWordEdit,
    phoneNumber: phoneNumber,
    BannerManger: BannerManger,
    FileManager: FileManager,
    examInfoManager: examInfoManager
  },
  created: function created() {// var that = this;
    // if (localStorage["userId"] !== undefined) {
    //   that.$store.dispatch(MU_UPATE_AUTH).then(rt => {});
    // }
  },
  methods: {
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  computed: {}
};